import React from "react";
import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  ASSET_STOCK_TAKING_UPLOAD_COUNT_DECREASE,
  ASSET_STOCK_TAKING_UPLOAD_COUNT_INCREASE,
  CHECK_ASSET_STOCK_TAKING_SUCCESS,
  CLEAR_ASSET_STOCK_TAKING_DATA_SUCCESS,
  CREATE_ASSET_STOCK_TAKING_SUCCESS,
  FETCH_ASSET_STOCK_TAKING_SUCCESS,
  GET_ASSET_STOCK_TAKING_SUCCESS,
  GET_AST_ASSETS_BY_VOUCHER_SUCCESS,
  GET_AST_COMBINE_REPORT_SUCCESS,
  GET_VERIFIED_ASSET_COUNT_START,
  GET_VERIFIED_ASSET_COUNT_SUCCESS,
  SAVE_ASSET_STOCK_TAKING_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { message, notification, Icon } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";
import moment from "moment/moment";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_ASSET_STOCK_TAKING_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ASSET_STOCK_TAKING_QUERY,
    query
  };
};

export const checkResourceSuccess = ({ data }) => {
  return {
    type: CHECK_ASSET_STOCK_TAKING_SUCCESS,
    data
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_ASSET_STOCK_TAKING_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_STOCK_TAKING_SUCCESS,
    data
  };
};

export const clearData = () => {
  return {
    type: CLEAR_ASSET_STOCK_TAKING_DATA_SUCCESS,
  }
};

export const assetStockTakingUploadCountDecrease = () => {
  return {
    type: ASSET_STOCK_TAKING_UPLOAD_COUNT_DECREASE,
  }
}

export const assetStockTakingUploadCountIncrease = () => {
  return {
    type: ASSET_STOCK_TAKING_UPLOAD_COUNT_INCREASE,
  }
}


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { assetStockTaking } = store.getState();
      const { query } = assetStockTaking;
      const response = await axios.get(`/asset-stock-taking?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const checkResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/asset-stock-taking/check`, payload);
      dispatch(fetchSuccess());
      dispatch(checkResourceSuccess({ data: response.data || '' }));
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { assetStockTaking } = store.getState();
      const { query } = assetStockTaking;
      const response = await axios.get(`/asset-stock-taking/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, update) => {
  return async (dispatch) => {
    // console.log(payload)
    dispatch(fetchStart());

    try {
      let formData = new FormData();
      let fileData = new FormData();

      Object.keys(payload).forEach(key => {
        if (key === 'assetDetails') {
          for (let i = 0; i < payload[key][0]['fileData'].length; i++) {
            fileData.append(`files`, payload[key][0]['fileData'][i]);
          }
          return formData.append(key, JSON.stringify(payload[key]));
        }
        formData.append(key, payload[key]);
      });

      const response = await axios.post(`/asset-stock-taking`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });

      if (fileData.has('files')) {
        fileData.append('id', response.data._id);
        fileData.append('assetCode', payload['assetDetails'][0]['assetCode'])
        const kk = axios.post('/asset-stock-taking/upload-files-in-background', fileData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } })
          .then(async response => {
            if (response.status === 201) {
              dispatch(assetStockTakingUploadCountDecrease());
              const { assetStockTaking } = store.getState();
              const { astUploadCount } = assetStockTaking;
              if (astUploadCount) {
                notification.info({
                  placement: 'bottomRight',
                  message: `Image upload in progress`,
                  description: `Asset's images left to be uploaded : ${astUploadCount}`,
                })
              } else {
                notification.destroy();
                notification.open({
                  placement: 'bottomRight',
                  message: `All the images have been uploaded`,
                })
              }
            }
          });
      }
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));
      if (!update) {
        history.push(`/asset-stock-taking/view/${response.data._id}`);
      } else {
        history.push(`/asset-stock-taking/edit/${response.data._id}`);
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id, update) => {
  return async (dispatch) => {
    // console.log(payload)
    dispatch(fetchStart());

    try {
      let formData = new FormData();
      let fileData = new FormData();
      Object.keys(payload).forEach(key => {
        if (key === 'assetDetails') {
          for (let i = 0; i < payload[key][0]['fileData'].length; i++) {
            fileData.append(`files`, payload[key][0]['fileData'][i]);
          }
          delete payload[key][0]['fileData'];
          return formData.append(key, JSON.stringify(payload[key]));
        }
        formData.append(key, payload[key]);
      });

      await axios.put(`/asset-stock-taking/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });

      if (fileData.has('files')) {
        fileData.append('id', id);
        dispatch(assetStockTakingUploadCountIncrease())
        const { assetStockTaking } = store.getState();
        const { astUploadCount } = assetStockTaking;
        if (astUploadCount) {
          notification.info({
            placement: 'bottomRight',
            message: `Image upload in progress`,
            description: `Asset's images left to be uploaded : ${astUploadCount}`,
          })
        }
        fileData.append('assetCode', payload['assetDetails'][0]['assetCode'])
        axios.post('/asset-stock-taking/upload-files-in-background', fileData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } })
          .then(async response => {
            if (response.status === 201) {
              dispatch(assetStockTakingUploadCountDecrease());
              const { assetStockTaking } = store.getState();
              const { astUploadCount } = assetStockTaking;
              if (astUploadCount) {
                notification.info({
                  placement: 'bottomRight',
                  message: `Image upload in progress`,
                  description: `Asset's images left to be uploaded : ${astUploadCount}`,
                })
              } else {
                notification.destroy();
                notification.success({
                  placement: 'bottomRight',
                  message: `All the images have been uploaded`,
                })
              }
            }
          });
      }

      dispatch(fetchSuccess());
      message.success('Asset details has been updated.');
      if (!update) {
        history.push(`/asset-stock-taking/view/${id}`);
      } else {
        history.push(`/asset-stock-taking/edit/${id}`);
        dispatch(getResource());
      }
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const submitReport = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.put(`/asset-stock-taking/submit-report/${id}`);
      dispatch(fetchSuccess());
      message.success('Report has been Submitted');
      history.push(`/asset-stock-taking`);
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/asset-stock-taking/${id}`);
      if (response && response.data) {
        const { data } = response;
        for (let i = 0; i < data.assetDetails.length; i++) {
          const d = data.assetDetails[i];
          if (d.link_record) {
            const record = await axios.get(`/asset-link/get-by-code/${d.link_record}`);
            if (record && record.data)
              d.link_record = record.data
          }
        }
        dispatch(fetchSuccess());
        dispatch(fetchResourceSuccess({ data }));
      } else { dispatch(fetchSuccess()); dispatch(fetchResourceSuccess({ data: null })); }
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/asset-stock-taking/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const updateAstAssetDetailField = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      if (!payload || !payload._id) {
        message.error('Record not found');
        dispatch(fetchSuccess());
        return;
      }
      const response = await axios.put(`/asset-stock-taking/asset-detail-field-update/${payload._id}`, payload);
      if (response && (response.status === 200 || response.status === 201)) {
        message.success('Updated successfully');
        dispatch(fetchResource(payload._id));
      }
      dispatch(fetchSuccess());
    } catch (error) {
      const msg = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message : 'Update failed';
      message.error(msg);
      dispatch(fetchError(msg));
      console.log("Error****:", msg);
    }
  };
};

export const removeAstAssetDetail = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      if (!payload || !payload._id) {
        message.error('Record not found');
        dispatch(fetchSuccess());
        return;
      }
      const response = await axios.put(`/asset-stock-taking/remove-asset-detail/${payload._id}`, payload);
      if (response && (response.status === 200 || response.status === 201)) {
        message.success('Record removed');
        dispatch(fetchResource(payload._id));
      }
      dispatch(fetchSuccess());
    } catch (error) {
      const msg = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message : 'Remove failed';
      message.error(msg);
      dispatch(fetchError(msg));
      console.log("Error****:", msg);
    }
  };
};

export const downloadViewReport = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/asset-stock-taking/${id}`);
      const { data } = response;
      const assets = data.assetDetails;
      let maxPhotoSize = 0;
      const listPromise = assets.map(async doc => {
        const photos = (doc.photos || []).map((image) => image.url);
        if (photos.length > maxPhotoSize) {
          maxPhotoSize = photos.length
        }
        let docs = [
          data.astNo || '',
          data.location && data.location.name || '',
          data.client && data.client.name || '',
          data.status || '',
          data.submittedBy && data.submittedBy.name || '',
          data.user && data.user.name || '',
          data.createdAt && moment(data.createdAt).format('DD/MM/YYYY') || '',
          doc.assetCode || '',
          doc.condition && doc.condition.name || '',
          doc.manual ? 'Manual' : 'QR Code',
          doc.isQrMismatched ? 'Yes' : 'No',
          doc.link_record || '',
          doc.latitude || '-',
          doc.longitude || '-',
          doc.remark || "",
          doc.time && moment(doc.time).format('DD/MM/YYYY hh:mm a'),
        ];
        return docs.concat(photos);
      }
      );
      const allAssetsData = await Promise.all(listPromise);
      const prom = new Promise(resolve => {
        const header = ['AST', 'Location', 'Client', 'Status', 'Submitted By', 'Opened By', 'Created At', 'Asset',
          'Condition', 'Entry Type', 'IS QR Mismatched', 'Link ID', 'Lat', 'Lng', 'Remark', 'Time'];
        for (let i = 1; i <= maxPhotoSize; i++) {
          header.push('Attachment_' + i)
        }
        let csvContent = allAssetsData.map(e => e.join(",")).join("\n");
        csvContent = header.join(",") + "\n" + csvContent;
        resolve(csvContent);
      });
      const content = await Promise.all([prom]);
      downloadCSV(content && content.length > 0 && content[0], "ast");
      dispatch(fetchSuccess());

    } catch
    (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const getVerifiedAssetCount = () => {
  return async dispatch => {
    dispatch(getVerifiedAssetCountStart());
    try {
      const from = moment().subtract(12, 'months').format('YYYY-MM-DDT00:00:01.000+0000');
      const to = moment().format('YYYY-MM-DDT23:59:59.000+0000');
      const response = await axios.get(`/asset-stock-taking/get-stocked-count/${from}/${to}`);
      // console.log(response);
      dispatch(getVerifiedAssetCountOk(response.data[0]));
    } catch (error) {
      dispatch(getVerifiedAssetCountOk({ count: 0 }));
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getVerifiedAssetCountOk = ({ count }) => {
  return {
    type: GET_VERIFIED_ASSET_COUNT_SUCCESS,
    count
  };
};

export const getVerifiedAssetCountStart = () => {
  return {
    type: GET_VERIFIED_ASSET_COUNT_START
  };
};

export const getASTCombineReport = (payload) => {
  return async dispatch => {
    dispatch(fetchStart());
    try {
      const { periodFrom, periodTo, location, subLocation } = payload;
      const response = await axios.get(`/asset-stock-taking/combine-ast-report/${location}/${subLocation}/${periodFrom.format('YYYY-MM-DD')}/${periodTo.format('YYYY-MM-DD')}`);
      // console.log(response.data);
      dispatch(getCombineReportSuccess(response));
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getCombineReportSuccess = ({ data }) => {
  return {
    type: GET_AST_COMBINE_REPORT_SUCCESS,
    data
  };
};

export const downloadASTCombineReport = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let maxPhotoSize = 0;
      const listPromise = data.map(async doc => {
        const assetDetail = doc.assetDetails;
        const photos = (assetDetail.photos || []).map((image) => image.url);
        if (photos.length > maxPhotoSize) {
          maxPhotoSize = photos.length
        }

        let tag = assetDetail && assetDetail.assetTagging; // && assetDetail.assetTagging.length && assetDetail.assetTagging[record.assetDetail.assetTagging.length - 1].id
        tag = (tag || []).filter(t => t.asset === (assetDetail.asset && assetDetail.asset[0]._id) || t.asset === (assetDetail.asset && assetDetail.asset[0].assetCode));
        const assetTag = tag && tag.length && tag[tag.length - 1];
        const scanData = assetTag && assetTag.scannerData || [];
        const qr = scanData && scanData.length && scanData[scanData.length - 1] && scanData.length && scanData[scanData.length - 1].id || '';

        let docs = [
          doc.astNo || '',
          doc.location && doc.location.name || '',
          doc.subLocation && doc.subLocation.name || '',
          doc.status || '',
          doc.submittedBy && doc.submittedBy.name || '',
          doc.user && doc.user.name || '',
          doc.createdAt && moment(doc.createdAt).format('DD-MM-YYYY') || '',
          assetDetail && assetDetail.assetCode || '',
          assetDetail && assetDetail.condition && assetDetail.condition.name || '',
          assetDetail && assetDetail.manual ? 'Manual' : 'QR Code',
          (assetDetail && assetDetail.isQrMismatched) ? 'Yes' : 'No',
          assetDetail && assetDetail.link_record,
          qr,
          assetDetail.latitude || '-',
          assetDetail.longitude || '-',
          assetDetail.remark || "",
          assetDetail.time && moment(assetDetail.time).format('DD-MM-YYYY hh:mm a'),
        ];

        for (let i = 0; i < maxPhotoSize; i++) {
          if (photos && photos.length && photos[i])
            docs.push(photos[i])
          else
            docs.push('')
        }
        return docs; //.concat(photos);
      }
      );
      const allAssetsData = await Promise.all(listPromise);
      const prom = new Promise(resolve => {
        const header = ['AST', 'Location', 'Client', 'Status', 'Submitted By', 'Opened By', 'Created At', 'Asset',
          'Condition', 'Entry Type', 'QR Mismatched', 'AT No', 'QR Id', 'Lat', 'Lng', 'Remark', 'Time'];
        for (let i = 1; i <= maxPhotoSize; i++) {
          header.push('Attachment_' + i)
        }
        let csvContent = allAssetsData.map(e => e.join(",")).join("\n");
        csvContent = header.join(",") + "\n" + csvContent;
        resolve(csvContent);
      });
      const content = await Promise.all([prom]);
      downloadCSV(content && content.length > 0 && content[0], "ast_combine");
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const addNewASTImage = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      let fileData = new FormData();

      Object.keys(payload).forEach(key => {
        if (key === 'assetDetails') {
          if (payload[key] && payload[key][0] && payload[key][0]['fileData'] && payload[key][0]['fileData'].length) {
            for (let i = 0; i < payload[key][0]['fileData'].length; i++) {
              fileData.append(`files`, payload[key][0]['fileData'][i]);
            }
          }
          if (payload[key] && payload[key][0] && payload[key][0]['assetCode'])
            fileData.append('assetCode', payload[key][0]['assetCode'])
          return formData.append(key, JSON.stringify(payload[key]));
        }
        formData.append(key, payload[key]);
      });

      if (fileData.has('files')) {
        if (payload && payload['_id']) {
          fileData.append('id', payload['_id']);
        } else {
          return message.error('Record Not Updated');
        }

        notification.destroy();
        notification.open({
          placement: 'bottomRight',
          message: <div><h4>Uploading ... </h4><Icon type={'loading'} /></div>
        })
        axios.post('/asset-stock-taking/add-files-in-background', fileData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } })
          .then(async response => {
            if (response.status === 201) {
              if (payload && payload['_id'])
                dispatch(fetchResource(payload['_id']));

              notification.destroy();
              notification.open({
                placement: 'bottomRight',
                message: `All the images have been uploaded`,
              })

              dispatch(fetchSuccess());
            }
          });
      }
      dispatch(fetchSuccess());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error));
    }
  }
};

export const getASTAssetsBuAuditVocher = (auditVoucher) => {
  return async dispatch => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/asset-stock-taking/assetsByAuditVoucher/${auditVoucher}`);
      console.log(response.data);
      dispatch(getASTAssetsByAuditVocherSuccess(response));
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getASTAssetsByAuditVocherSuccess = ({ data }) => {
  return {
    type: GET_AST_ASSETS_BY_VOUCHER_SUCCESS,
    data
  };
};
